import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
    Table, Popup, Button
} from 'semantic-ui-react';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-top: -10px;
    margin-bottom: 0px;
    padding: 0px 0px;
   }    
`;

const StyledTableHeader = styled(Table.Header)`
&&& th {
    padding: 4px;
    margin: 0px 0px 0px 0px;
}
`;

const StyledTableBody = styled(Table.Body)`
&&& 
 td{
    padding: 2px 2px !important;
    margin: 0px 0px 0px 0px !important;
}

`;
class Financeiro extends Component {
    state = {
        sortColumn: null,
        sortDirection: null
    }

    constructor(props) {
        super(props);
    }

    onSave = (item) => {
        let entidade = {}
        entidade.nufin = item.nufinArray;
        entidade.userid = parseInt(this.props.userid); // Convertendo para número inteiro
        entidade.motorista = item.motorista
        this.props.despesasDeViagensSaveFinanceiroGeradoAction(entidade)
    }

    handleSort = (clickedColumn) => () => {
        const { sortColumn, sortDirection } = this.state;

        if (sortColumn !== clickedColumn) {
            this.setState({
                sortColumn: clickedColumn,
                sortDirection: 'ascending'
            });
            return;
        }

        this.setState({
            sortDirection: sortDirection === 'ascending' ? 'descending' : 'ascending'
        });
    }

    getOrdensDeCarga = (item) => {
        return [...new Set((item.ordensDeCarga || [])
            .map(oc => oc.ordemcarga)
            .filter(oc => oc !== undefined && oc !== null && oc !== ''))];
    }

    getOrdensDeCargaText = (item) => {
        return this.getOrdensDeCarga(item).join(', ');
    }

    getOrdemCargaSortValue = (item) => {
        const ordensDeCarga = this.getOrdensDeCarga(item);
        const ordensNumericas = ordensDeCarga
            .map(oc => Number(oc))
            .filter(oc => !Number.isNaN(oc));

        if (ordensNumericas.length > 0) {
            return Math.min(...ordensNumericas);
        }

        return ordensDeCarga.join(', ').toString().toLowerCase();
    }

    getSortValue = (item, column) => {
        switch (column) {
            case 'veiculo':
                return (item.placa || item.veiculo || '').toString().toLowerCase();
            case 'ordemcarga':
                return this.getOrdemCargaSortValue(item);
            case 'motorista':
                return (item.motorista || '').toString().toLowerCase();
            case 'valor':
                return Number(item.valoresdob) || 0;
            case 'dtfinanceiro': {
                const dateValue = moment(item.dtprocfinanceiro).valueOf();
                return Number.isNaN(dateValue) ? 0 : dateValue;
            }
            default:
                return '';
        }
    }

    getSortedDatalist = () => {
        const { datalist } = this.props;
        const { sortColumn, sortDirection } = this.state;

        if (!sortColumn) {
            return [...datalist];
        }

        return [...datalist].sort((a, b) => {
            const aValue = this.getSortValue(a, sortColumn);
            const bValue = this.getSortValue(b, sortColumn);
            const direction = sortDirection === 'descending' ? -1 : 1;

            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return (aValue - bValue) * direction;
            }

            return aValue.toString().localeCompare(bValue.toString(), 'pt-BR', { numeric: true }) * direction;
        });
    }

    render() {
        let { userid, usersfin } = this.props
        const { sortColumn, sortDirection } = this.state;
        const sortedDatalist = this.getSortedDatalist();
        let blnBloqueia = false
        let useridString = userid.toString();
        if (usersfin.includes(useridString)) {
            blnBloqueia = false
        }

        return (
            <StyledTable celled sortable id="listGerados" compact='very' size='small'>
                <StyledTableHeader>
                    <Table.Row >
                        <Table.HeaderCell width="1" sorted={sortColumn === 'veiculo' ? sortDirection : null} onClick={this.handleSort('veiculo')}>Veículo</Table.HeaderCell>
                        <Table.HeaderCell width="1" sorted={sortColumn === 'ordemcarga' ? sortDirection : null} onClick={this.handleSort('ordemcarga')}>Ordem de Carga</Table.HeaderCell>
                        <Table.HeaderCell width="3" sorted={sortColumn === 'motorista' ? sortDirection : null} onClick={this.handleSort('motorista')}>Motorista</Table.HeaderCell>
                        <Table.HeaderCell width="1" sorted={sortColumn === 'valor' ? sortDirection : null} onClick={this.handleSort('valor')}>Valor</Table.HeaderCell>
                        <Table.HeaderCell width="2" sorted={sortColumn === 'dtfinanceiro' ? sortDirection : null} onClick={this.handleSort('dtfinanceiro')}>DT Financeiro</Table.HeaderCell>
                        <Table.HeaderCell width="1"></Table.HeaderCell>
                    </Table.Row>
                </StyledTableHeader>

                <StyledTableBody>
                    {sortedDatalist.map(item => (
                        <Table.Row key={`${item.motorista}_${item.nufin}`}>
                            <Popup
                                trigger={<Table.Cell>{item.placa}</Table.Cell>}
                                content={item.veiculo}
                                inverted
                            />
                            <Table.Cell>{this.getOrdensDeCargaText(item)}</Table.Cell>
                            <Popup
                                trigger={
                                    <Table.Cell>
                                        {item.motorista}
                                    </Table.Cell>
                                }
                                flowing
                                hoverable
                                on={["hover", "click"]}
                            >
                                <p>Motorista: <b>{item.motorista}</b></p>
                                <table border='1px' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}><b>OC</b></th>
                                            <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>NUFIN</th>
                                            <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>VALOR</th>
                                            <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>NATUREZA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(item.ordensDeCarga || []).map(itempopup => (
                                            <tr
                                                key={itempopup.ordemcarga}
                                                style={{
                                                    backgroundColor: itempopup.natureza === "Adiantamento" ? "red" : "transparent",
                                                    color: itempopup.natureza === "Adiantamento" ? "white" : "black",
                                                }}
                                            >
                                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{itempopup.ordemcarga}</td>
                                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{itempopup.nufin}</td>
                                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(itempopup.valorespopup)}</td>
                                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{itempopup.natureza}</td>
                                            </tr>
                                        ))}

                                        {/* Calculando o total ajustado */}
                                        {(() => {
                                            const totalAdiantamentos = (item.ordensDeCarga || [])
                                                .filter(itempopup => itempopup.natureza === "Adiantamento")
                                                .reduce((acc, curr) => acc + curr.valorespopup, 0);

                                            const totalRecalculado = item.valoresdob - totalAdiantamentos;

                                            return (
                                                <>
                                                    {Object.entries((item.totalPorOrdemDeCarga && item.totalPorOrdemDeCarga[0]) || {}).map(([chave, valor]) => (
                                                        <tr key={chave}>
                                                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }} colSpan={2} align='right'><b>Total OC {chave}:</b></td>
                                                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)}</td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }} colSpan={2} align='right'><b>Total:</b></td>
                                                        <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(totalRecalculado)}</td>
                                                    </tr>
                                                </>
                                            );
                                        })()}
                                    </tbody>
                                </table>
                            </Popup>


                            <Table.Cell>
                                {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valoresdob)}
                            </Table.Cell>
                            <Table.Cell>
                                {moment(item.dtprocfinanceiro).format("DD/MM/YYYY HH:mm")}
                            </Table.Cell>
                            <Table.Cell>
                                <Button
                                    key={`save_${item.ordemcarga}`} basic
                                    icon={'gavel'} color={'green'} size="mini"
                                    onClick={(e) => this.onSave(item)}
                                    loading={item.issaving}
                                    disabled={blnBloqueia}
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </StyledTableBody>
            </StyledTable >
        )
    }
}

Financeiro.defaultProps = {
    datalist: [],
    userid: "",
    usersfin: []
};

Financeiro.propTypes = {
    datalist: PropTypes.array.isRequired,
    userid: PropTypes.string.isRequired,
    usersfin: PropTypes.array.isRequired,
    despesasDeViagensSaveFinanceiroGeradoAction: PropTypes.func.isRequired
};

export default Financeiro;
